import { preroutePromptCall } from "./preroutePromptRoutes/call";
import { preroutePromptChat } from "./preroutePromptRoutes/chat";
import { preroutePromptLive } from "./preroutePromptRoutes/live";
import { preroutePromptMedia } from "./preroutePromptRoutes/media";

/**
 * ルート進入前の先回りモーダル（Carina・完全新規・未消費）。
 * 止まった行動を「相手 or 中身・値段と手持ちでできる量・やり直すボタン 1 つ」で見せる。
 * 「無料」「今だけ」など誤解させる表現や、女性側から誘っているように見せる言い回しは使わない。
 * 値段と手持ちでできる量は必ず併記する（ポイントを使うことを隠さない）。
 * ルートごとの文言は preroutePromptRoutes/<ルート>.ts（ルート別の PR で入れる）。
 */
export const preroutePrompt = {
  /** 見出しの上の導入。消費直前（さっきの行動のやり直し） */
  leadStop: "さっきの続き",
  /** 見出しの上の導入。物色（さっき見た相手） */
  leadBrowse: "さっき見ていた人",
  /** 写真の代替テキスト */
  photoAlt: (args: { name: string | number }) => `${args.name}さんの写真`,
  /** 手持ちでできる時間（30 秒単位） */
  duration: (args: { minutes: number; seconds: number }) =>
    args.seconds > 0
      ? `${args.minutes} 分 ${args.seconds} 秒`
      : `${args.minutes} 分`,
  /** CTA 下の注記: いまの手持ち */
  balance: (args: { point: string | number }) => `いまの手持ち ${args.point}pt`,
  media: preroutePromptMedia,
  call: preroutePromptCall,
  chat: preroutePromptChat,
  live: preroutePromptLive,
} as const;
